import Vue from 'vue'
import http, { expandURI } from '@/utils/ajax'
import { REVENUECHART_INIT_LOADING, REVENUECHART_INIT_SUCCESS, REVENUECHART_INIT_FAIL } from '@/store/types'
import { extractMenu } from '@/utils/extract'

const state = {
  revenueChart: {
    init: 0,
    menu: {},
    lastUpdated: null,
    scope: null,
    appId: null,
    info: null,
    appIds: [],
    chartInfo: []
  }
}

const getters = {

}

const actions = {
  async initRevenueChart({ commit, state }, data) {
    commit(REVENUECHART_INIT_LOADING)
    const apiUrl = state.permitWidgets.revenueChart
    if (apiUrl) {
      try {
        let params = {
          scope: data.scope,
          appId: data.appId
        }
        const result = await http.get(expandURI(apiUrl, params))
        const menu = extractMenu(result.data._links)

        Object.assign(data, {
          menu: menu,
          info: result.data.info,
          appIds: result.data.appIds,
          chartInfo: result.data.chartInfo
        })
        commit(REVENUECHART_INIT_SUCCESS, data)
      } catch (error) {
        commit(REVENUECHART_INIT_FAIL)
      }
    } else {
      commit(REVENUECHART_INIT_FAIL)
    }
  }
}

const mutations = {
  [REVENUECHART_INIT_LOADING](state) {
    state.revenueChart.init = 0
  },
  [REVENUECHART_INIT_SUCCESS](state, data) {
    const { revenueChart } = state
    revenueChart.menu = data.menu
    revenueChart.init = 1
    revenueChart.lastUpdated = new Date()
    revenueChart.scope = data.scope
    revenueChart.appId = data.appId
    revenueChart.info = data.info
    revenueChart.appIds = data.appIds
    Vue.set(revenueChart, 'chartInfo', data.chartInfo)
  },
  [REVENUECHART_INIT_FAIL](state) {
    state.revenueChart.init = 2
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
